import { cn } from "@/utils/cn";
import type { InputState } from "./Input.types";

type StyleProps = {
  state?: InputState;
  disabled?: boolean;
  iconLeft?: string;
  readonly?: boolean;
  clickable?: boolean;
  variant?: "default" | "outline" | "filled";
};

export const getInputStyles = ({
  state = "default",
  disabled,
  iconLeft,
  readonly,
  clickable,
  variant,
}: StyleProps) => {
  return {
    wrapper: cn("flex w-full flex-col gap-2"),
    label: cn("font-bold text-sm text-dark-100"),
    inputContainer: cn(
      "flex h-[clamp(42px,4vh,50px)] gap-[10px] rounded-[12px] bg-dark items-center px-[20px] transition-all border border-transparent",
      {
        "flex-row-reverse": iconLeft,
        "focus-within:border-dark-200": state === "default" && !disabled,
        "border-error": state === "error",
        "border-success": state === "success",
        "bg-dark-300 border-dark-500 hover:border-dark-500 focus-within:border-dark-500": readonly,
        "bg-dark-300 opacity-50 cursor-not-allowed": disabled,
        "focus-within:border-transparent": disabled,
        "border-transparent": disabled,
        "border-dark-400": variant === "outline",
        "bg-dark-400 border-dark-500 focus-within:border-dark-200": variant === "filled",
      }
    ),
    icon: cn(
      "text-dark-100 transition-colors cursor-default",
      {
        "text-error": state === "error",
        "text-success": state === "success",
        "text-dark-500": readonly,
      },
      {
        "cursor-pointer hover:text-primary": clickable && !disabled,
        "cursor-not-allowed": clickable && disabled,
      }
    ),
    input: cn(
      "w-full h-full bg-transparent p-0",
      "font-medium text-dark-100",
      "placeholder:text-dark-300 placeholder:text-[12px] placeholder:italic",
      "focus:outline-none focus:ring-0",
      "disabled:cursor-not-allowed",
      {
        "text-error": state === "error",
        "text-success": state === "success",
        "text-dark-200 placeholder:text-dark-200": disabled,
        "text-dark-500": readonly,
      }
    ),
    helperText: cn("text-xs mt-1", {
      "text-error": state === "error",
      "text-success": state === "success",
      "text-dark-200": state === "default",
    }),
  };
};
